import { Grid } from '@mui/material'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { useSelector } from 'react-redux'
import RecentClientComponent from './RecentClientComponent'

interface RecentClientsProps {}

const userRecentFilesSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.userRecentFiles,
)
const projectsSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.projects,
)

const RecentClientsComponent: React.FC<RecentClientsProps> = ({}) => {
  const useRecentFiles = useSelector(userRecentFilesSelector)
  const projects = useSelector(projectsSelector)

  return (
    <Grid container spacing='1rem'>
      {useRecentFiles?.slice(0, 3).map((recentFile) => {
        return (
          <Grid
            size={4}
            key={recentFile.id}
            sx={{
              boxSizing: 'border-box',
              boxShadow: '0px 2px 10px 0px #0000001A',
              padding: '0.75rem',
              border: '2px solid transparent',
              borderRadius: '0.4rem',
              '&:hover': {
                border: '2px solid #1705E5',
              },
            }}
          >
            <RecentClientComponent
              clientId={
                projects.find(
                  (project) => project.id === recentFile.file.project_id,
                )?.client_id
              }
            />
          </Grid>
        )
      })}
    </Grid>
  )
}

export default RecentClientsComponent
